export const validation = {
  data () {
    return {
      modelValidation: {
        fullname: {
          required: true
        },
        opf: {
          required: true
        },
        city: {
          alpha: true
        },
        inn: {
          required: true,
          numeric: true,
          min: 10,
          max: 12
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: false,
          regex: /^((\+7|7|8)+([0-9]){10})$/
        },
        fio: {
          required: true,
          alpha_spaces: true
        },
        login: {
          required: true,
          regex: /^[A-Za-z0-9._@-]+$/
        },
        password: {
          required: true
        },
        role: {
          required: true
        },
        contract: {

        },
        contractDate: {

        },
        org_id: {

        },
        emails: {
          regex: /^([\w+-.%]+@[\w.]+\.[A-Za-z]{2,4},?)+$/
        }
      },
      priceValidation: {
        required: true,
        regex: /^\d{0,10}[.]?\d{0,2}?$/
      },
      accountValidation: {
        required: false,
        regex: /^\d{0,10}[.]?\d{0,2}?$/
      }
    }
  },
  methods: {
    getError (ref) {
      return this.veeErrors.first(ref)
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        this.sendLogic()
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
      })
    }
  }
}
